import { render, staticRenderFns } from "./AccountOrderDetails.vue?vue&type=template&id=bda58b90&"
import script from "./AccountOrderDetails.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports